import React from 'react';
import { Button, Modal } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export default function BankRequestSubmittedModal({ open, message, onClose }) {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width={440}
      destroyOnClose
      onCancel={onClose}
      styles={{ body: { padding: '28px 24px 24px' } }}
    >
      <div className="flex flex-col items-center text-center">
        <span
          className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-[0_4px_14px_rgba(33,181,70,0.35)]"
          aria-hidden
        >
          <CheckOutlined style={{ fontSize: 26, fontWeight: 700 }} />
        </span>
        <h2 className="mt-4 text-lg font-semibold text-gray-900">Bank request submitted</h2>
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-gray-500">
          {message || 'Your bank details and documents have been submitted for review.'}
        </p>
      </div>
      <div className="mt-6">
        <Button type="primary" block onClick={onClose} className="!h-11 !rounded-xl !font-semibold">
          OK
        </Button>
      </div>
    </Modal>
  );
}
